import React, { Component,useCallback } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Input, Col, Row, Button, Radio, message, InputNumber,DatePicker,Switch,Tooltip } from 'antd'
import * as actions  from '@/models/bonusCoupon/services'
import dayjs from 'dayjs';
import {
  QuestionCircleOutlined,
} from '@ant-design/icons';
const { TextArea } = Input;
const { RangePicker } = DatePicker;
@Form.create()
class BonusCouponDialogComponent extends Component {
  state = {
    loading: false,
    couponType: 1,
    cumulative: false 
  }
 
  handleSubmit = e => {
    const { coupon = {}, ismodify, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      this.setState({ loading: true })
      if (ismodify !== "modify") {
        actions.addBonusCoupon({
          name: values.name,
          fromTime: values.fromToTime[0],
          toTime: values.fromToTime[1],
          expiration: values.expiration,
          couponType: values.couponType,
          orders: values.orders,
          coupons: values.coupons,
          amount: values.amount,
          memo: values.memo,
          times: values.times,
          cumulative: this.state.cumulative
        }).then(result => {
          message.success('添加成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        actions.updateBonusCoupon(coupon._id, {
        name: values.name,
        fromTime: values.fromToTime[0],
        toTime: values.fromToTime[1],
        expiration: values.expiration,
        couponType: values.couponType,
        orders: values.orders,
        coupons: values.coupons,
        amount: values.amount,
        memo: values.memo,
        times: values.times,
        cumulative: this.state.cumulative
        }).then(result => {
          message.success('修改成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      }
    });
  }
  componentDidMount() {

  }
  render() {
    const {  coupon = {},disabled } = this.props
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    }
    const onChange = e => {
      if(coupon){
        coupon.couponType  = e.target.value
      }
      this.setState({couponType:e.target.value });
    };
    const onCumulativeChange = checked => {
      this.setState({cumulative:checked})
    }
    return (
      <div>
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          <Row>
            <Col span={24}>
              <Form.Item 
                label="奖金券名称"
                required>
                {getFieldDecorator('name', {
                  initialValue: coupon.name,
                  rules: [
                    {
                      required: true,
                      message: '请输入奖金券名称',
                    },
                  ],
                })(
                  <Input disabled={disabled} style={{ width: 300 }} placeholder="请输入奖金券名称" />
                )}
              </Form.Item>
              <Form.Item 
                label="奖金券类型"
                required>
                {getFieldDecorator('couponType', {
                  initialValue: coupon.couponType,
                  rules: [
                    {
                      required: true,
                      message: '奖金券类型',
                    },
                  ],
                })(
                 <Radio.Group onChange={onChange}>
                    <Radio value={1}>注册奖励</Radio>
                    <Radio value={2}>完单奖励</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
              { (coupon?.couponType==2||this.state.couponType==2) &&
              <Row>
              <Col span={10}>
                <Form.Item labelCol={{span:15}} wrapperCol={{span:9}}
                  label="完单数量要求"
                  required>
                  {getFieldDecorator('orders', {
                    initialValue: coupon.orders,
                    rules: [
                      {
                        required: true,
                        message: '请输入完单数量要求',
                      },
                    ],
                  })(
                    <InputNumber disabled={disabled} min={1} precision={0} />
                  )}
                </Form.Item>
                </Col>
                <Col span={10}>
                <Form.Item labelCol={{span:12}} wrapperCol={{span:12}}
                  label="可领取次数"
                  >
                  {getFieldDecorator('times', {
                    initialValue: coupon.times?coupon.times:null,
                    rules: [
                      {
                        required: false,
                        message: '请输入可领取次数',
                      },
                    ],
                  })(
                    <InputNumber disabled={disabled} min={1} precision={0} placeholder="无限制"/>
                  )}
                </Form.Item>
                </Col>
              </Row>
               }
              <Form.Item
              required
              label="起止时间"
              >
              {getFieldDecorator('fromToTime',{
                initialValue: [dayjs(coupon.fromTime),dayjs(coupon.toTime)]
              })(
                <RangePicker style={{width:300}}
                  format="YYYY-MM-DD"
                  placeholder="选择起止时间"
                />
              )}
            </Form.Item>
            <Row>
            <Col span={10}>
              <Form.Item labelCol={{span:15}} wrapperCol={{span:9}}
                label="使用有效期(天)" 
                required>
                {getFieldDecorator('expiration', {
                  initialValue: coupon.expiration,
                  rules: [
                    {
                      required: true,
                      message: '请输入奖金券使用有效期',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={1} precision={0} />
                )}
              </Form.Item>
              </Col>
              { (coupon?.couponType==2||this.state.couponType==2) &&
              <Col span={10}>
              <Form.Item  labelCol={{span:12}} wrapperCol={{span:12}}
                label="超额叠加">
                {getFieldDecorator('cumulative', {
                  initialValue: coupon.cumulative,
                  valuePropName: 'checked',
                  rules: [
                    {
                      required: false,
                      message: '超额叠加',
                    },
                  ],
                })(
                  <Switch disabled={disabled} onChange={onCumulativeChange} />
                )}
                <Tooltip placement="top" title="奖券根据完单数量按奖励等级由低到高依次领取"><QuestionCircleOutlined style={{marginLeft:5}}/></Tooltip>
              </Form.Item>
              </Col> }
              </Row>
              <Row>
            <Col span={10}>
              <Form.Item  labelCol={{span:15}} wrapperCol={{span:9}}
                label="奖金券面值(元)"
                required>
                {getFieldDecorator('coupons', {
                  initialValue: coupon.coupons,
                  rules: [
                    {
                      required: true,
                      message: '请输入奖金券面值',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={0.1} precision={1} />
                )}
              </Form.Item>
              </Col>
              <Col span={10}>
              <Form.Item  labelCol={{span:12}} wrapperCol={{span:12}}
                label="奖金券数量"
                required>
                {getFieldDecorator('amount', {
                  initialValue: coupon.amount,
                  rules: [
                    {
                      required: true,
                      message: '请输入奖金券数量',
                    },
                  ],
                })(
                  <InputNumber disabled={disabled} min={1} precision={0}  />
                )}
              </Form.Item>
              </Col>
              </Row>
              <Form.Item 
                label="使用说明">
                {getFieldDecorator('memo', {
                  initialValue: coupon.memo,
                  rules: [
                    {
                      required: false,
                      message: '请输入使用说明',
                    },
                  ],
                })(
                  <TextArea disabled ={disabled} style={{ width: 300 }}  rows={4}  placeholder="请输入使用说明" />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col style={{textAlign:"center"}}>
                  <Button type="primary" disabled={disabled} htmlType="submit">保存</Button>
              </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const BonusCouponDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={590}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <BonusCouponDialogComponent onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'BONUS_COUPON_DIALOG',
})(BonusCouponDialog)
